import React from 'react';
import { useL10n } from '@uplift/hooks';
import { PatientSearchAutocomplete } from './PatientsAutocomplete.component';


export const UserInfoExisting: React.VFC = () => {
  const l10n = useL10n();

  return (
    <PatientSearchAutocomplete
      label="Client"
      name="existingPatient"
      placeholder={l10n.schedule.createAppointment.searchExistingClients}
    />
  );
};
